import FolderService from "./folder";

export default FolderService;
